import {ThemeProvider, Toaster} from '@hmlet/ui'

import {createRouter} from '@tanstack/react-router'
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {I18nextProvider} from 'react-i18next'

import './index.css'

import TanstackProvider from '@config/TanstackProvider'
import {UserProvider} from '@contexts/UserContext'
import i18n from '@translations/i18n'

import AppRouter from './AppRouter'
import {routeTree} from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!, // provided at runtime by AppRouter
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <I18nextProvider i18n={i18n}>
        <TanstackProvider>
          <UserProvider>
            <Toaster richColors />
            <AppRouter />
          </UserProvider>
        </TanstackProvider>
      </I18nextProvider>
    </ThemeProvider>
  </StrictMode>,
)
